import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { ServiceRequestService } from '../service-request.service';
import { ServiceRequest } from '../service-request.model';

export const serviceRequestResolver: ResolveFn<ServiceRequest> = async (
  route: ActivatedRouteSnapshot,
): Promise<ServiceRequest> => {
  const _serviceRequestService: ServiceRequestService = inject(ServiceRequestService);

  return await _serviceRequestService.show(route.params['id']);
};
